import { gql } from '@apollo/client';

export const getModulesQueryBody = `
  query GetModules {
    moduleMany {
      _id
      name
      roles
    }
  }
`;

export const getModulesQuery = gql`
  ${getModulesQueryBody}
`;
